import styled from 'styled-components';

const EmailLabel = styled.div.attrs(()=>({ className: 'text-muted fs-sm' }))`
  marginTop: '0px';
  marginBottom: '3px';
`

export default EmailLabel;
